import { RetrenchmentAssessmentDetailsView } from '../../assessment/decisions';
import { IncomeCalculator } from '../../assessment/income-calculator';
import { RetrenchmentSynopsis } from '../../assessment/synopsis';
import { ClaimAuditTrailView } from '../../claim-audit-trail';
import { DashboardFlowView } from '../../assesor-dashboard/views/dashboard/assessor-dashboard';
import { ClaimType } from '../../claim/claim-types';
import { WorkflowScreen } from '../../workflow-navigation/reducers/workflow-screen';
import { WorkflowStep } from '../../workflow-navigation/reducers/workflow-step';
import { WorkflowUtilityScreen } from '../../workflow-navigation/reducers/workflow-utility-screen';
import { WorkflowAssessorScreen } from '../../workflow-navigation/reducers/workflow-assessor';
import { ClaimWorkflow } from './claim-workflow';
import { ScreenGuard } from './screen-index';

import { AuthGuard } from '../../auth/authGuard';

const assessorDashboardGuard = AuthGuard(['AssessorDashboard']);

export const retrenchmentWorkflow = new ClaimWorkflow(
    'Retrenchment',
    [
        new WorkflowStep('Initiate Claim', []),
        new WorkflowStep('Assessment', [
            new WorkflowScreen('Synopsis', RetrenchmentSynopsis, undefined, undefined, ScreenGuard),
            new WorkflowScreen(
                'Decisions',
                RetrenchmentAssessmentDetailsView,
                undefined,
                undefined,
                ScreenGuard
            ),
            new WorkflowScreen(
                'Income Calculator',
                IncomeCalculator,
                undefined,
                undefined,
                ScreenGuard
            ),
        ]),
        new WorkflowAssessorScreen(
            'Assessor List',
            'Assessor limits dashboard',
            DashboardFlowView,
            undefined,
            'Assessor limits dashboard',
            assessorDashboardGuard
        ),
        new WorkflowUtilityScreen(
            'Claim Audit Trail',
            'list',
            ClaimAuditTrailView,
            undefined,
            undefined,
            ScreenGuard
        ),
    ],
    claim => claim.claimType === ClaimType.Retrenchment,
    undefined,
    ScreenGuard
);
